import React, { useCallback, useEffect, useRef, useState } from "react";
import { history_ai, history_curated } from "../../Services/apiRoutes";
import { updateDates } from "../../utils/DatePagination";
import { CircularProgress, Grid } from "@mui/material";
import BasicCard from "../../components/card";
import BasicModal from "../../components/Modal";
import { getCryptoLogoMap } from "../../utils/utility";


let coinSymbol = [];
const HistoryCards = () => {
  const currentDate = new Date();
  const sd = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 7).toISOString().substring(0, 10);
  const ed = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 2).toISOString().substring(0, 10);
  const [positiveCards, setPositiveCards] = useState([]);
  const [negativeCards, setNegativeCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [iconURL, setIconURL] = useState({});
  const [page, setPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const debounceTimer = useRef(null);

  const isFetched = useRef(false);

  const testRef = useRef({
    start: sd,
    end: ed,
  });
  const [cardDetails, setCardDetails] = useState({});
  const [open, setOpen] = useState(false);

  const onReadMore = (cardDetails) => {
    setCardDetails(cardDetails);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setCardDetails(false);
  };

  // console.log("date cards", dateRange);
  const fetchCuratedCards = async () => {
    try {
      const data = await history_curated(testRef.current);
      let positiveData = [...positiveCards, ...data.data.positive];
      let negativeData = [...negativeCards, ...data.data.negative];
      pushCoins([...data.data.positive, ...data.data.negative]);
      getCoinData();
      positiveData = positiveData.sort((a, b) => new Date(b.datetime) - new Date(a.datetime));
      negativeData = negativeData.sort((a, b) => new Date(b.datetime) - new Date(a.datetime));
      setPositiveCards(positiveData);
      setNegativeCards(negativeData);
    } catch (error) {
      console.log("in history curated", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllCards = async () => {
    Promise.allSettled([history_curated(testRef.current), history_ai(testRef.current, page)])
      .then(async (results) => {
        const fulfilledResults = results.filter((result) => result.status === "fulfilled").map((result) => result.value);

        const CuratedData = fulfilledResults[0];
        const AiData = fulfilledResults[1];
        let positiveData = [...positiveCards, ...CuratedData?.data?.positive?.reverse(), ...AiData?.data?.positive];
        let negativeData = [...negativeCards, ...CuratedData?.data?.negative?.reverse(), ...AiData?.data?.negative];
        pushCoins([...positiveData, ...negativeData]);

        getCoinData();

        positiveData = positiveData.sort((a, b) => new Date(b.datetime) - new Date(a.datetime));
        negativeData = negativeData.sort((a, b) => new Date(b.datetime) - new Date(a.datetime));
        setPositiveCards(positiveData);
        setNegativeCards(negativeData);
        setPage(prevPage => prevPage + 1);
      })
      .catch((error) => {
        console.log("Error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchAiCards = async () => {
    try {
      console.log("fetchAiCards");
      const data = await history_ai(testRef.current, page);
      if (data.data.positive.length === 0 && data.data.negative.length === 0) {
        setHasMoreData(false);
      }
      let positiveData = [...positiveCards, ...data.data.positive];
      let negativeData = [...negativeCards, ...data.data.negative];
      pushCoins([...data.data.positive, ...data.data.negative]);
      getCoinData();
      positiveData = positiveData.sort((a, b) => new Date(b.datetime) - new Date(a.datetime));
      negativeData = negativeData.sort((a, b) => new Date(b.datetime) - new Date(a.datetime));
      setPositiveCards(positiveData);
      setNegativeCards(negativeData);

      setPage(prevPage => prevPage + 1);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  function handleHashChange() {
    const newHash = window.location.hash;
    if (newHash === "#curated") {
      fetchCuratedCards();
    } else if (newHash === "#ai") {
      fetchAiCards();
    } else {
      fetchAllCards();
    }
  }

  const getCoinData = async () => {
    var result = await getCryptoLogoMap(coinSymbol);
    setIconURL(result);
    return result;
  };

  const pushCoins = (dataArray) => {
    dataArray.forEach((data) => {
      if (data.coins.length)
        data?.coins?.forEach((coin) => {
          coinSymbol.push(coin);
        });
    });
  };
  const fetchData = () => {
    handleHashChange();
  };
  useEffect(() => {
    if (!isFetched.current) {
      fetchData();
      isFetched.current = true;
    }
  }, []);



  useEffect(() => {
    const newHash = window.location.hash;
    if (newHash !== "#curated") {
      const scrollableElement = document.getElementById('nlp-card-scrollable');

      const handleScroll = () => {
        if (hasMoreData && !loading) {
          if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
          }

          debounceTimer.current = setTimeout(() => {
            if (
              scrollableElement &&
              scrollableElement.scrollTop + scrollableElement.clientHeight >=
              scrollableElement.scrollHeight - 20
            ) {
              setLoading(true);
              fetchAiCards();
            }

            debounceTimer.current = null;
          }, 300);

        }
        // if (hasMoreData &&
        //   scrollableElement &&
        //   scrollableElement.scrollTop + scrollableElement.clientHeight >=
        //   scrollableElement.scrollHeight - 20 && !loading
        // ) {
        //   setLoading(true);
        //   fetchAiCards();
        // }
      };

      if (scrollableElement) {
        scrollableElement.addEventListener('scroll', handleScroll);
      }

      return () => { 
        if (scrollableElement) {
          scrollableElement.removeEventListener('scroll', handleScroll);
        }
        if (debounceTimer.current) {
          clearTimeout(debounceTimer.current);
        }
      };
    }
  }, [loading, hasMoreData]);

  return (
    <div
      style={{
        minHeight: "100px",
        marginTop: "40px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {open && <BasicModal open={open} handleClose={handleClose} cardDetails={cardDetails} />}
      {(positiveCards.length === 0 && negativeCards.length === 0) ? (

        <div></div>
        // <div
        //   style={{
        //     display: "flex",
        //     justifyContent: "center",
        //     marginTop: "50px",
        //     marginLeft: "auto",
        //     marginRight: "auto",
        //   }}
        // >
        //   <CircularProgress />
        // </div>
      ) : (
        <Grid
          container
          sx={{
            justifyContent: "center",
            marginTop: "20px",
            gap: "2.5vw",
            display: "flex",
          }}
          className="grid-container"
        >
          {/* left side cards */}
          {/* sm={isTablet?5.8:1} md={4} */}
          <Grid container alignContent="flex-start" gap="3vw" width="48.5%" maxWidth="500px">
            {positiveCards.map((sentiment) => (
              <Grid
                key={sentiment?._id}
                item
                sx={{
                  width: "100%",
                }}
              >
                <BasicCard positive category={sentiment.Category} icons={iconURL} title={sentiment.title} text={sentiment.text} curated={sentiment.curated} score={sentiment.weighted_average} channel={sentiment.channel} coins={sentiment.coins} handle={sentiment.handle} datetime={sentiment.datetime} onReadMore={onReadMore} />
              </Grid>
            ))}
          </Grid>

          <Grid container alignContent="flex-start" gap="3vw" width="48.5%" maxWidth="500px">
            {negativeCards.map((sentiment) => (
              <Grid
                key={sentiment._id}
                item
                sx={{
                  width: "100%"

                }}
              >
                <BasicCard positive={false} category={sentiment.Category} icons={iconURL} title={sentiment.title} text={sentiment.text} curated={sentiment.curated} score={sentiment.weighted_average} channel={sentiment.channel} coins={sentiment.coins} handle={sentiment.handle} datetime={sentiment.datetime} onReadMore={onReadMore} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}
      {loading && <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "50px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <CircularProgress />
      </div>}
    </div>

  );
};

export default React.memo(HistoryCards);
